package model

import kotlinx.serialization.Serializable
import kotlin.math.PI
import kotlin.math.cos
import kotlin.math.sqrt

@Serializable
data class GeoPoint(
    val lat: Double,
    val lon: Double,
    val accuracyMeters: Double? = null,
)

private const val EARTH_RADIUS_METERS = 6_371_000.0

private fun Double.toRadians(): Double = this * PI / 180.0

// Equirectangular approximation, accurate enough at the few-kilometer distances used for nearby stores
fun GeoPoint.distanceMetersTo(other: GeoPoint): Double {
    val lat1 = lat.toRadians()
    val lat2 = other.lat.toRadians()

    val x = (other.lon.toRadians() - lon.toRadians()) * cos((lat1 + lat2) / 2.0)
    val y = lat2 - lat1

    return sqrt(x * x + y * y) * EARTH_RADIUS_METERS
}
